// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"bfy_a bhv_vc bhv_rm bhv_wf"};